/**
 * WorkshopInitializer
 * Main entry point for workshop page functionality
 *
 * Contract:
 * - May be bundled globally
 * - Must silently no-op if workshop DOM is not present
 */

import DatePickerModal from './DatePickerModal.js';

class WorkshopInitializer {
  constructor() {
    this.components = {};
    this.init();
  }

  init() {
    // Initialize only components that are actually needed
    this.components.datePickerModal = new DatePickerModal();
  }

  // Expose components for potential external access
  getComponent(name) {
    return this.components[name];
  }
}

// Safe, idempotent boot
function bootWorkshop() {
  // Prevent double-init
  if (window.workshopApp) return;

  // Gate on workshop-specific DOM
  // Check for any event type data elements (workshop, hhh, icm, group)
  const workshopRoot =
    document.querySelector('[data-workshop]') ||
    document.querySelector('.workshop-page') ||
    document.getElementById('workshop-data') ||
    document.getElementById('hhh-data') ||
    document.getElementById('icm-data') ||
    document.getElementById('group-data');

  // Not an event page → silently no-op
  if (!workshopRoot) return;

  window.workshopApp = new WorkshopInitializer();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootWorkshop);
} else {
  bootWorkshop();
}

export default WorkshopInitializer;
